import { styled } from '@mui/system';
import { rem } from 'polished';

export const Text = styled('span')({
  paddingRight: rem(10),
});
